import ExternalLink from '../single/externalLink';

const Robust = () => {
	return (
		<>
		<h2 id="robust">Principio 4. <ExternalLink href="https://www.w3.org/TR/WCAG21/#robust" contents="Robusto" /></h2>
		<blockquote>
		<p>El contenido debe ser lo bastante robusto como para que pueda ser interpretado por una amplia gama de agentes de usuario, incluidas las tecnologías de apoyo.</p>
		</blockquote>
		</>
	)
}

export default Robust;
